import { render, staticRenderFns } from "./AlphaNumHalfKanaInput.vue?vue&type=template&id=09bf6e96&scoped=true&"
import script from "./AlphaNumHalfKanaInput.vue?vue&type=script&lang=ts&"
export * from "./AlphaNumHalfKanaInput.vue?vue&type=script&lang=ts&"
import style0 from "./AlphaNumHalfKanaInput.vue?vue&type=style&index=0&id=09bf6e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bf6e96",
  null
  
)

export default component.exports